export var PROPERTY_CARD_BADGE_APPEARANCES = Object.freeze({
  DEFAULT: 'default',
  NOTIFICATION: 'notification',
  ZILLOW: 'zillow'
});